export default __webpack_public_path__ + "static/MAC-cf3d319aa1aba68dd2ee39b667171e4b.png";